import styled from 'styled-components';

export const SideBoxFooter = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 8px 0;
`;

export const PartnershipImage = styled.img`
  width: 100%;
  object-fit: contain;
  max-height: 36px;
`;
